import type { IconData } from '@stacksjs/iconify-core'

export const otherUiCrown: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 5L0 1v7.75a1.25 1.25 0 1 1 0 2.5V15h16v-3.75a1.25 1.25 0 1 1 0-2.5V1l-4 4l-4-4zm4 6.25a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiCrown
